<script lang="ts">
  // kwento.photos: for a guest whose phone has no QR scanner. One field, one button, and as light as the guest page.
  import { normalizeEventCode } from '../lib/code'
  import { isGuestLocale, setLocale, t, type Locale } from '../lib/i18n'
  import Header from './Header.svelte'
  import LangSwitcher from './LangSwitcher.svelte'

  // Here there is no event yet, so the choice is kept for the device (a guest who picked Bisaya here should not be asked again at the party).
  let lang = $state<Locale>('en')
  const KEY = 'kwento:lang'
  async function pick(l: Locale) {
    await setLocale(l)
    lang = l
    try {
      localStorage.setItem(KEY, l)
    } catch {
      // private window: the choice just does not stick
    }
  }
  try {
    const saved = localStorage.getItem(KEY)
    if (isGuestLocale(saved) && saved !== 'en') void pick(saved)
  } catch {
    // no storage: English until the guest picks
  }

  let value = $state('')
  let message = $state('')
  let busy = $state(false)

  async function go(e: Event) {
    e.preventDefault()
    message = ''
    const code = normalizeEventCode(value)
    if (!code) {
      message = t('m2.codeBad')
      return
    }
    busy = true
    try {
      // Ask first, so an unknown code is said so here instead of on a page that cannot help.
      const res = await fetch(`/api/e/${code}`)
      if (res.status === 404) message = t('m2.codeUnknown')
      else if (res.ok && /json/i.test(res.headers.get('content-type') ?? '')) location.assign(`/e/${code}`)
      else message = t('m2.codeOffline')
    } catch {
      message = t('m2.codeOffline')
    } finally {
      busy = false
    }
  }
</script>

<LangSwitcher {lang} onPick={pick} />
{#key lang}
<main class="g-page">
  <Header title="kwento" />
  <form class="g-stack g-grow" onsubmit={go}>
    <h1 class="g-display">{t('m2.codeTitle')}</h1>
    <p class="g-lead">{t('m2.codeHint')}</p>
    <div class="g-field">
      <label for="code">{t('m2.codeLabel')}</label>
      <input
        id="code"
        class="g-input code"
        name="code"
        type="text"
        inputmode="text"
        autocapitalize="characters"
        autocomplete="off"
        autocorrect="off"
        spellcheck="false"
        aria-invalid={message !== ''}
        aria-describedby="code-message"
        bind:value
      />
      <div id="code-message" role="alert">{#if message}<div class="g-error">{message}</div>{/if}</div>
    </div>
    <button type="submit" class="g-button" disabled={busy || value.trim() === ''}>{t('m2.codeGo')}</button>
  </form>
  <footer class="g-footer"><span>{t('common.noAppNeeded')}</span></footer>
</main>
{/key}
